import { connect } from 'react-redux';

import AdvancePayInvoicesPresentation from './AdvancePayInvoicesPresentation';

import { invoicesActions } from 'dataflow/billingPortal/actions';

function mapStateToProps(state) {
    const { userPermissions } = state.userManagementReducers;

	return {
        ...state.invoicesReducers,
        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getInvoiceList: (pageNo, pageSize, sort, filterOptions) => { dispatch(invoicesActions.getInvoiceList(pageNo, pageSize, sort, filterOptions)); },

        deleteInvoice: (invoiceId) => { dispatch(invoicesActions.deleteInvoice(invoiceId)); },
        postToSQLAccount: (invoiceId, refDocNo) => { dispatch(invoicesActions.postToSQLAccount(invoiceId, refDocNo)); },
        postCreditNote: (invoiceId) => { dispatch(invoicesActions.postCreditNote(invoiceId)); },
        sendEmail: (invoiceId, isSentToCustomers) => { dispatch(invoicesActions.sendEmail(invoiceId, isSentToCustomers)); },
    };
}

const AdvancePayInvoices = connect(mapStateToProps, mapDispatchToProps)(AdvancePayInvoicesPresentation);

export default AdvancePayInvoices;